import ResourceTyped from 'Resources/ResourceTyped';
import { STYLE, TYPE } from 'Store/reducers/SystemNotificationReducer';
import type Contact from './Model/Contact';

export type ContactRelation = {
	contactId: number;
	relatedToClientId: number;
	description: string;
	id: number;
};

// The Contact API response includes connectedClients but the Contact model type can't declare it —
// that breaks Contact → Partial<Client> structural assignability (Client.connectedClients is ConnectedClient[])
export type ContactWithRelations = Contact & {
	connectedClients?: ContactRelation[];
};

class ContactRelationResource extends ResourceTyped<ContactRelation> {
	eventName = 'contactRelation';
	constructor() {
		super('contactrelation');
		this.notifications = {
			save: (_data: unknown, opts?: { isNew?: boolean }) => ({
				title: 'default.saved',
				body: opts?.isNew === false ? 'updated.relation' : 'saved.relation',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.relation',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			}),
			delete: () => ({
				title: 'default.saved',
				body: 'deleted.relation',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			deleteError: () => ({
				title: 'default.error',
				body: 'deleteError.relation',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			})
		};
	}
}

const contactRelationResource = new ContactRelationResource();

export default contactRelationResource;
